document.addEventListener('DOMContentLoaded', () => {
  const slider = new Swiper('.slider', {
    loop: true,
    navigation: {
      nextEl: ".slider__button_next",
      prevEl: ".slider__button_prev"
    },
    pagination: {
      el: ".slider__pagination",
      clickable: true
    }
  })
})
